export default {
  STARTUPS: '/api/startups',
  LOCATIONS: '/api/startups/search-terms',
  LOGIN: '/api/auth/login',
  STATS: '/api/startups/stats'
}